/* eslint-disable @typescript-eslint/no-unused-vars */
import { Modal as Modal } from "bootstrap";

for (const [id, config] of Object.entries(MODALS)) {
  $(`#modal-button-${id}`).on("click", () => {
    $("#modal-container").html(modalContent(config));
    $(`#modal-${id}`).modal("show");
  });
}

const modalContent = (modal) => {
  return `
    <div class="modal fade" id="modal-${
      modal.id
    }" tabindex="-1" aria-labelledby="modal-label-${
    modal.id
  }" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          ${
            modal.action
              ? `<form action="${modal.action}${EXT}" method="${modal.method}">`
              : ""
          }
            <div class="modal-header">
              <h5 class="modal-title" id="modal-label-${modal.id}">${
    modal.title
  }</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              ${modal.body}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="${modal["submit-type"]}" class="btn btn-${
    modal["submit-class"]
  }" id="button-${modal.id}">${modal["submit-text"]}</button>
            </div>
          ${modal.action ? "</form>" : ""}
        </div>
      </div>
    </div>
  `;
};
